import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, Table, Button, Row, Col } from 'react-bootstrap';
import { FaFileDownload, FaShare, FaEdit, FaTrash } from 'react-icons/fa';
import { generateInvoicePDF } from '../utils/pdfGenerator';

function InvoiceDetail() {
  const { id } = useParams();
  const navigate = useNavigate();

  // Mock data - replace with actual data fetching
  const invoice = {
    id: 'INV-001',
    from: {
      name: 'Construction Co Ltd',
      address: '789 Builder Street',
      city: 'Construction City, ST 12345',
      phone: '(555) 123-4567',
      email: 'billing@constructionco.com'
    },
    client: 'Acme Construction',
    jobSite: '123 Main St',
    jobCode: 'AC-001',
    date: '2024-05-22',
    status: 'Pending',
    lineItems: [
      {
        id: '1',
        description: 'Foundation Work',
        jobCode: 'FDN-01',
        hours: '8',
        rate: '75.00',
        amount: '600.00'
      },
      {
        id: '2',
        description: 'Framing',
        jobCode: 'FRM-01',
        hours: '12',
        rate: '85.00',
        amount: '1,020.00'
      },
      {
        id: '3',
        description: 'Electrical Installation',
        jobCode: 'ELC-01',
        hours: '6',
        rate: '95.00',
        amount: '570.00'
      }
    ]
  };

  const handleDownload = () => {
    const doc = generateInvoicePDF(invoice);
    doc.save(`invoice-${invoice.id}.pdf`);
  };

  const handleShare = () => {
    // TODO: Implement sharing functionality
    console.log('Sharing invoice:', id);
  };

  const handleEdit = () => {
    // TODO: Implement edit functionality
    console.log('Editing invoice:', id);
  };

  const handleDelete = () => {
    // TODO: Implement delete functionality
    console.log('Deleting invoice:', id);
    navigate('/invoices');
  };

  const calculateTotal = () => {
    return invoice.lineItems
      .reduce((sum, item) => sum + parseFloat(item.amount.replace(',', '')), 0)
      .toFixed(2);
  };

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h1 className="h3 mb-0">Invoice {invoice.id}</h1>
          <p className="text-secondary mb-0">
            Created on {invoice.date}
          </p>
        </div>
        <div className="d-flex gap-2">
          <Button
            variant="outline-primary"
            className="d-flex align-items-center"
            onClick={handleDownload}
          >
            <FaFileDownload className="me-2" /> Download PDF
          </Button>
          <Button
            variant="outline-primary"
            className="d-flex align-items-center"
            onClick={handleShare}
          >
            <FaShare className="me-2" /> Share
          </Button>
          <Button
            variant="primary"
            className="d-flex align-items-center"
            onClick={handleEdit}
          >
            <FaEdit className="me-2" /> Edit
          </Button>
          <Button
            variant="danger"
            className="d-flex align-items-center"
            onClick={handleDelete}
          >
            <FaTrash className="me-2" /> Delete
          </Button>
        </div>
      </div>

      <Row className="g-4 mb-4">
        <Col md={6}>
          <Card>
            <Card.Body>
              <h2 className="h5 mb-3">From</h2>
              <dl className="mb-0">
                <dt className="text-secondary">Company</dt>
                <dd className="mb-2">{invoice.from.name}</dd>
                <dt className="text-secondary">Address</dt>
                <dd className="mb-2">{invoice.from.address}</dd>
                <dd className="mb-2">{invoice.from.city}</dd>
                <dt className="text-secondary">Contact</dt>
                <dd className="mb-0">
                  {invoice.from.phone}<br />
                  {invoice.from.email}
                </dd>
              </dl>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6}>
          <Card>
            <Card.Body>
              <h2 className="h5 mb-3">Client Information</h2>
              <dl className="mb-0">
                <dt className="text-secondary">Client Name</dt>
                <dd className="mb-2">{invoice.client}</dd>
                <dt className="text-secondary">Job Site</dt>
                <dd className="mb-2">{invoice.jobSite}</dd>
                <dt className="text-secondary">Job Code</dt>
                <dd className="mb-0">{invoice.jobCode}</dd>
              </dl>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Card>
        <Card.Body>
          <h2 className="h5 mb-4">Line Items</h2>
          <div className="table-responsive">
            <Table>
              <thead>
                <tr>
                  <th style={{ width: '35%' }}>Description</th>
                  <th>Job Code</th>
                  <th>Hours</th>
                  <th>Rate</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {invoice.lineItems.map((item) => (
                  <tr key={item.id}>
                    <td>{item.description}</td>
                    <td>{item.jobCode}</td>
                    <td>{item.hours}</td>
                    <td>${item.rate}</td>
                    <td>${item.amount}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan="4" className="text-end fw-bold">
                    Total:
                  </td>
                  <td className="fw-bold">${calculateTotal()}</td>
                </tr>
              </tfoot>
            </Table>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default InvoiceDetail; 